import React from "react";
//import {connect} from "react-redux";
import {CheckboxTable} from "../../../view/CheckboxTable";
//import {debug} from "../../utils";
import PortsTableRow from "./PortsTableRow";


function PortsTable({portsList}) {

    //TODO implement
    const headers = [
        {name: 'PORT', onClick: () => {}},
        {name: 'STATUS', onClick: () => {}},
        {name: 'SERVICES', onClick: () => {}},
    ]

    return (
        <>
            {portsList.length > 0 ?
            <CheckboxTable headers={headers} elements={portsList}>
                {portsList.map((port, index) => <PortsTableRow key={index} data={port} index={index}/>)}
            </CheckboxTable>
            :
            <div className="text-center">Network Inventory Ports not found</div>}
        </>
    )

}


// function mapStateToProps(state) {
//     debug("InventoryScanTable mapStateToProps", state);
//     const inventoryPage = state.inventoryPage;
//     return {
//         inventoryList: inventoryPage.inventoryList || []
//     };
// }


//export default connect(mapStateToProps)(PortsTable);
export default PortsTable;
